'use strict';
const svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	writeNodeDecorations = require('./write-node-decorations'),
	lineStrokes = require('@mindmup/mapjs-core/src/theme/line-strokes');
module.exports = function writeNode(node, nodeView, textEngine, stickersEngine) {
	if (!node || !nodeView || !textEngine || !stickersEngine || !stickersEngine.writeStickers) {
		throw new Error('invalid-args');
	}
	const nodeElement = svgMarkupBuilder('g').attr('transform', 'translate(' + node.x + ',' + node.y + ')'),
		bubble = svgMarkupBuilder('rect').attr(nodeView.metrics.bubble).attr({
			rx: nodeView.theme.cornerRadius,
			ry: nodeView.theme.cornerRadius
		}).appendTo(nodeElement),
		effectiveLineColor = (nodeView.theme.lineColor !== 'transparent'
			&& nodeView.theme.borderType === 'surround' && nodeView.theme.lineColor);

	if (nodeView.theme.backgroundColor && nodeView.theme.backgroundColor !== 'transparent') {
		bubble.css('fill', nodeView.theme.backgroundColor);
	}
	if (effectiveLineColor) {
		bubble.css({
			stroke: effectiveLineColor,
			'stroke-width': nodeView.theme.lineWidth,
			//check if we need to default it
			'stroke-dasharray': lineStrokes[nodeView.theme.lineStyle || 'solid']
		});
	}
	if (nodeView.icon && nodeView.icon.url) {
		svgMarkupBuilder('image').attr(Object.assign({'xlink:href': nodeView.icon.url}, nodeView.metrics.icon)).appendTo(nodeElement);
	}
	if (nodeView.title) {
		nodeElement.append(textEngine.writeNodeText(nodeView));
	}
	writeNodeDecorations(textEngine, stickersEngine, nodeView, nodeElement);
	return nodeElement;
};
